export default __webpack_public_path__ + "static/media/alok.2e27d6b6.jpg";